module.exports = __webpack_public_path__ + "static/media/36.d3fceb2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/36.svg
// module id = 2827
// module chunks = 3